export const isRefObject = (ref: any): ref is React.RefObject<HTMLElement> => {
  return typeof ref === 'object' && 'current' in ref;
};
